
import { useTranslation } from 'react-i18next';

export default function MarketInsightsSection() {
  const { t } = useTranslation();
  
  const insights = [
    {
      icon: 'ri-money-dollar-circle-line',
      value: '¥3 trillion+',
      label: 'Chinese fashion retail market',
      subtitle: 'by 2025',
      description: 'The Chinese fashion market continues to grow rapidly, presenting unprecedented opportunities for European brands.'
    },
    {
      icon: 'ri-line-chart-line',
      value: '12%+',
      label: 'CAGR for mid-to-high-end European brands',
      subtitle: 'annual growth',
      description: 'European luxury and premium brands are experiencing exceptional growth in the Chinese market.'
    },
    {
      icon: 'ri-store-line',
      value: '5000+',
      label: 'buyer stores and department store partners',
      subtitle: 'nationwide network',
      description: 'Our extensive retail network ensures maximum market penetration and brand visibility.'
    }
  ];

  return (
    <section id="insights" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black" style={{ fontFamily: 'Playfair Display, serif' }}>
            {t('marketInsightsTitle')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('marketInsightsDescription')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {insights.map((insight, index) => (
            <div key={index} className="text-center bg-gray-50 rounded-lg p-8 hover:bg-gray-100 transition-colors duration-300">
              <div className="w-16 h-16 mx-auto mb-6 bg-amber-600 text-white rounded-full flex items-center justify-center">
                <i className={`${insight.icon} text-2xl`}></i>
              </div>
              <div className="text-4xl font-bold text-black mb-2">
                {insight.value}
              </div>
              <div className="text-lg font-semibold text-gray-800 mb-2">
                {insight.label}
              </div>
              <div className="text-sm text-amber-600 font-medium mb-4">
                {insight.subtitle}
              </div>
              <p className="text-gray-600 leading-relaxed">
                {insight.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="bg-black text-white rounded-lg p-12 text-center">
          <h3 className="text-3xl font-bold mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Ready to Enter the Chinese Market?
          </h3>
          <p className="text-xl mb-8 text-gray-300 max-w-3xl mx-auto">
            Join hundreds of European fashion brands who have successfully expanded into China through our proven B2B platform and expertise.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-2xl font-bold text-amber-400 mb-2">98%</div>
              <div className="text-gray-300">Success Rate</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-amber-400 mb-2">30 Days</div>
              <div className="text-gray-300">Average Setup</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-amber-400 mb-2">24/7</div>
              <div className="text-gray-300">Support</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-amber-400 mb-2">15+</div>
              <div className="text-gray-300">Years Experience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
